// Action types
export const SEARCH_SET_TYPE_SORTING = 'SEARCH:SET_TYPE_SORTING';
export const SEARCH_UPDATE_QUERY = 'SEARCH:UPDATE_QUERY';
export const SEARCH_REPLACE_FILTER_INPUTS = 'SEARCH:REPLACE_FILTER_INPUTS';
export const SEARCH_UPDATE_FILTERS_APPLIED = 'SEARCH:UPDATE_FILTERS_APPLIED';

// Search type constants
export const SEARCH_TYPES = {
    COLLEGES: 'colleges',
    HIGH_SCHOOLS: 'highSchools',
};
